var map = {
	"./wLock.svg": 60192,
	"./wdiscord.svg": 33226,
	"./wgitbook.svg": 58480,
	"./whale.svg": 23703,
	"./whiteForm.svg": 72358,
	"./wtelegram.svg": 92281,
	"./wtwitter.svg": 71830
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51400;